import { FormControl, MenuItem, Select } from '@mui/material'
import { useByStudent } from '../../ByStudentContext/ByStudentContext'
import { isEmpty } from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { updateFilter } from '../../../../../../../store/actions/filter.actions'
import { updateSkip } from '../../../../../../../store/actions/datatable.actions'
import { useLocation, useNavigate } from 'react-router-dom'
import { useMemo } from 'react'

const SelectLA = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { currentCurriculum, studentSelected } = useByStudent()
  const filter = useSelector((state) => state?.filter.learningMatrix?.filter || {})
  const dispatch = useDispatch()
  const value = useMemo(() => {
    return filter?.curriculumElements?.[elementId].value?.[0] || ''
  }, [filter, elementId])
  if (!currentCurriculum || !currentCurriculum?.elements || !currentCurriculum.elementsStructure) return <></>
  const elementId = currentCurriculum?.elementsStructure?._id

  const onChangeHandler = (e) => {
    const newFilter = {
      ...filter,
      curriculumElements: {
        [elementId]: {
          value: [e.target.value]
        }
      },
      student: studentSelected
    }

    dispatch(updateFilter('learningMatrix', newFilter))
    dispatch(updateSkip('learningMatrix', 0))
    navigate(pathname, { state: filter })
  }

  return (
    <FormControl variant='outlined' className='max-w-120px min-w-120px'>
      <Select
        variant='outlined'
        value={value}
        onChange={onChangeHandler}
        size='small'
        displayEmpty={true}
        inputProps={isEmpty(value) ? { className: 'opacity-50' } : {}}
      >
        <MenuItem value='' disabled>
          Choose a option
        </MenuItem>
        {currentCurriculum?.elements?.children?.map((cur) => (
          <MenuItem key={`learing-area-${cur._id}`} value={cur._id}>
            {cur.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectLA
